import { render, staticRenderFns } from "./CustomerAuthScreen.vue?vue&type=template&id=119b9810&"
import script from "./CustomerAuthScreen.vue?vue&type=script&lang=js&"
export * from "./CustomerAuthScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports